export const SKILL_TRACKS = [
  {
    trackId: 'ski_progression_core',
    sport: 'skiing',
    name: 'Core Progression',
    type: 'progression',
    entryLevel: 'beginner',
    branchFromLevel: null,
    parentTrackId: null,
    order: 1,
    active: true,
  },
  {
    trackId: 'ski_all_mountain_fundamentals',
    sport: 'skiing',
    name: 'All-Mountain Fundamentals',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'ski_progression_core',
    order: 10,
    active: true,
  },
  {
    trackId: 'ski_carving_branch',
    sport: 'skiing',
    name: 'Carving',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'ski_progression_core',
    order: 11,
    active: true,
  },
  {
    trackId: 'ski_freeride_powder_branch',
    sport: 'skiing',
    name: 'Freeride / Powder',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'ski_progression_core',
    order: 12,
    active: true,
  },
  {
    trackId: 'ski_freestyle_park_branch',
    sport: 'skiing',
    name: 'Freestyle / Park',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'ski_progression_core',
    order: 13,
    active: true,
  },
  {
    trackId: 'ski_steeps_branch',
    sport: 'skiing',
    name: 'Steeps',
    type: 'branch',
    entryLevel: 'upper_intermediate',
    branchFromLevel: 'upper_intermediate',
    parentTrackId: 'ski_progression_core',
    order: 14,
    active: true,
  },
  {
    trackId: 'ski_bumps_branch',
    sport: 'skiing',
    name: 'Bumps',
    type: 'branch',
    entryLevel: 'upper_intermediate',
    branchFromLevel: 'upper_intermediate',
    parentTrackId: 'ski_progression_core',
    order: 15,
    active: true,
  },
  {
    trackId: 'snowboard_progression_core',
    sport: 'snowboarding',
    name: 'Core Progression',
    type: 'progression',
    entryLevel: 'beginner',
    branchFromLevel: null,
    parentTrackId: null,
    order: 1,
    active: true,
  },
  {
    trackId: 'snowboard_all_mountain_fundamentals',
    sport: 'snowboarding',
    name: 'All-Mountain Fundamentals',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'snowboard_progression_core',
    order: 10,
    active: true,
  },
  {
    trackId: 'snowboard_carving_branch',
    sport: 'snowboarding',
    name: 'Carving',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'snowboard_progression_core',
    order: 11,
    active: true,
  },
  {
    trackId: 'snowboard_freeride_powder_branch',
    sport: 'snowboarding',
    name: 'Freeride / Powder',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'snowboard_progression_core',
    order: 12,
    active: true,
  },
  {
    trackId: 'snowboard_freestyle_park_branch',
    sport: 'snowboarding',
    name: 'Freestyle / Park',
    type: 'branch',
    entryLevel: 'intermediate',
    branchFromLevel: 'intermediate',
    parentTrackId: 'snowboard_progression_core',
    order: 13,
    active: true,
  },
  {
    trackId: 'snowboard_steeps_branch',
    sport: 'snowboarding',
    name: 'Steeps',
    type: 'branch',
    entryLevel: 'upper_intermediate',
    branchFromLevel: 'upper_intermediate',
    parentTrackId: 'snowboard_progression_core',
    order: 14,
    active: true,
  },
];

export function getSkillTracksForSport(sport) {
  return SKILL_TRACKS.filter((track) => track.sport === sport && track.active)
    .sort((a, b) => a.order - b.order || a.name.localeCompare(b.name));
}
